import type { SVGAttributes } from "react"

export default function AppLogoIcon(props: SVGAttributes<SVGElement>) {
  return (
    <svg
      id="emoji"
      viewBox="0 0 72 72"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="color">
        <rect x="5" y="17" width="62" height="38" fill="#1e50a0" />
        <rect x="5" y="17" width="62" height="38" fill="#fff" />
        <rect x="5" y="42" width="62" height="13" fill="#61b2e4" />
        <rect x="5" y="17" width="62" height="13" fill="#61b2e4" />
        <polygon
          fill="#f1b31c"
          stroke="#f1b31c"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="36 33.897 37.236 32 37.176 34.299 39.236 33.528 37.902 35.35 40 36 37.902 36.65 39.236 38.472 37.176 37.701 37.236 40 36 38.103 34.764 40 34.824 37.701 32.764 38.472 34.098 36.65 32 36 34.098 35.35 32.764 33.528 34.824 34.299 34.764 32 36 33.897"
        />
      </g>
      <g id="line">
        <rect
          x="5"
          y="17"
          width="62"
          height="38"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </g>
    </svg>
  )
}
